import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11b644b3")

_pushScopeId("data-v-11b644b3")
const _hoisted_1 = { class: "column" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 0,
  class: "title"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_TreeTable = _resolveComponent("TreeTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_TreeTable, { value: _ctx.jobTreeTable }, {
    default: _withId(() => [
      _createVNode(_component_Column, {
        field: "name",
        header: _ctx.$t('autots.history.label.name'),
        expander: true,
        style: {"width":"37%"}
      }, {
        body: _withId(({ node }) => [
          _createTextVNode(_toDisplayString(_ctx.$t(node.data.name)), 1)
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "status",
        header: _ctx.$t('autots.label.status'),
        style: {"width":"10%"}
      }, {
        body: _withId(({ node }) => [
          _createVNode("div", _hoisted_1, [
            _withDirectives(_createVNode("span", {
              class: 'status-badge status-' + node.data.status.toLowerCase()
            }, [
              _createTextVNode(_toDisplayString(node.data.status), 1)
            ], 2), [
              [
                _directive_tooltip,
                _ctx.$t(_ctx.getTooltip(node)),
                void 0,
                { top: true }
              ]
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "startedTime",
        header: _ctx.$t('autots.history.label.started_time')
      }, {
        body: _withId(({ node }) => [
          (node.data.startedTime)
            ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$moment(node?.data?.startedTime).format("LLL")), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "endedTime",
        header: _ctx.$t('autots.history.label.ended_time')
      }, {
        body: _withId(({ node }) => [
          (node.data.endedTime)
            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$moment(node.data.endedTime).format("LLL")), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "duration",
        header: _ctx.$t('autots.history.label.duration'),
        style: {"width":"13%"}
      }, {
        body: _withId(({ node }) => [
          (node.data.duration)
            ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$moment.duration(node.data.duration, "seconds").humanize()), 1)
              ], 512)), [
                [
                  _directive_tooltip,
                  `${_ctx.$getDuration(node.data.duration)}`,
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["value"]))
})